import { useTranslation } from "react-i18next";
import { DiagnosticProps } from "../diagnostic.types";
import { Box, Button, Stack, Typography, useTheme } from "@mui/material";
import { WhiteBox, FoodsIllustrations, FoodsIcon } from "@foodpilot/foods";
import { DIAGNOSTIC_COLOR_INDEX } from "..";
import { URLHandler } from "src/services/URLHandler";
import { useCompanyMetadata } from "src/context/Company/Metadata/useCompanyMetadata";
import { useFoodpilotContext } from "src/context/FoodpilotContext";
import { Link } from "react-router";

export const EmptyDiagnostic = (props: DiagnosticProps) => {
    const { score } = props;
    const theme = useTheme();
    const { t } = useTranslation();

    const { currentCampaign } = useFoodpilotContext();
    const { company } = useCompanyMetadata();

    const ssqId = props.diagnostic?.id ?? -99;
    const campaignId = currentCampaign?.id ?? -99;

    const scoreName = score.title;
    const datavizColors = theme.custom.dataviz.colorsWithExtra[DIAGNOSTIC_COLOR_INDEX];
    const canViewSsq = props.diagnostic?.post ? props.diagnostic.post.canViewSsq : true;

    return (
        <WhiteBox padding={theme.spacing(3)}>
            <Stack gap={theme.spacing(4)}>
                <Stack gap={theme.spacing(2)} justifyContent={"center"} alignItems={"start"}>
                    <FoodsIllustrations illustration="wavingHand" variant={`dataviz-${DIAGNOSTIC_COLOR_INDEX}`} />
                    <Typography variant="h3">
                        {t("diagnostic.welcome", `Welcome on your {{score}}`, { score: scoreName })}
                    </Typography>
                    {canViewSsq && <Typography variant="body">{t("diagnostic.welcome.description", " ")}</Typography>}
                </Stack>
                {canViewSsq && (
                    <Box>
                        <Link
                            to={URLHandler.company.questionnaireScore(
                                company.id,
                                ssqId,
                                campaignId,
                                score.id.toString(),
                            )}
                        >
                            <Button
                                variant="primary"
                                endIcon={<FoodsIcon size={2} icon="arrowRight" />}
                                sx={{
                                    background: datavizColors.main,
                                    ":hover": {
                                        background: datavizColors.variant[700],
                                    },
                                }}
                            >
                                {t("questionnaire.complete_questionnaire", "Complete the questionnaire")}
                            </Button>
                        </Link>
                    </Box>
                )}
            </Stack>
        </WhiteBox>
    );
};
